export default __webpack_public_path__ + "static/media/img38.c8eed215.jpg";